
import "/root/workspace/__flow_work/__flow_builds/4ed6d599-55a5-4f85-8534-0c858affe5ce/workspace/saas-admin/src/components/MediaUploader/index.less?modules";
export default {"tips": `tips-KLho4vbx`,"txt": `txt-KtqHEj22`}
